var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPermMedia24Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 262,
    height: 262,
    viewBox: "0 0 262 262",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L262 0 262 262 0 262z",
    transform: "translate(-589 -335) translate(589 335)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    fillRule: "nonzero",
    d: "M21.833 65.6H0v54.5h.11L0 218.2C0 230.19 9.825 240 21.833 240h196.5v-21.8h-196.5V65.6zm218.334-21.8h-87.334L131 22H65.5c-12.008 0-21.724 9.81-21.724 21.8l-.11 130.8c0 11.99 9.826 21.8 21.834 21.8h174.667c12.008 0 21.833-9.81 21.833-21.8v-109c0-11.99-9.825-21.8-21.833-21.8zM76.417 163.7l49.125-65.4 38.208 49.159 27.292-32.809 38.208 49.05H76.417z",
    transform: "translate(-589 -335) translate(589 335)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermMedia24Px);
export default __webpack_public_path__ + "static/media/perm-media-24-px.77885140e0ca0632ee042d4700b16481.svg";
export { ForwardRef as ReactComponent };